<template>
    <div class="forbidden-container d-flex flex-column justify-content-center align-items-center vh-100">
        <h1 class="display-1 fw-bold text-danger">403</h1>
        <h2 class="text-muted">Access Denied</h2>
        <p class="text-center text-secondary">
            You do not have permission to view this page.
        </p>
        <router-link to="/" class="btn btn-primary mt-3">Go Home</router-link>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Forbidden",
});
</script>

<style scoped>
.forbidden-container {
    text-align: center;
}
</style>